import { TFunction } from 'i18next'
import { PaymentIntervalEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { assertNever } from 'utils/type-guard/assertNever'

type Input = {
  paymentInterval?: PaymentIntervalEnum
  multiYears?: number
  t: TFunction<'requests'>
}

export const getPriceFrequencyLabel = ({ paymentInterval, multiYears, t }: Input) => {
  if (paymentInterval === undefined) return ''

  switch (paymentInterval) {
    case PaymentIntervalEnum.WEEK:
      return t('company-info.price-per-week')
    case PaymentIntervalEnum.MONTH:
      return t('company-info.price-per-month')
    case PaymentIntervalEnum.QUARTER:
      return t('company-info.price-per-quarter')
    case PaymentIntervalEnum.EVERY_SIX_MONTHS:
      return t('company-info.price-per-six-months')
    case PaymentIntervalEnum.YEAR:
      return t('company-info.price-per-year')
    case PaymentIntervalEnum.MULTI_YEAR:
      return t('company-info.price-multi-years', { years: multiYears })
    case PaymentIntervalEnum.EVERY_TWO_YEARS:
      return t('company-info.price-multi-years', { years: 2 })
    case PaymentIntervalEnum.ONE_OFF:
      return ''
    default:
      assertNever(paymentInterval)
  }
}
